import AOS from 'aos';

AOS.init({
  easing: 'ease-in-out-sine',
  duration: 1000
});